import React,{useState}from 'react'
import Icon from '../atoms/Icon'

const PopUp = ({ message }) => {
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="mc-container-pop-up">
            <div className="mc-container-pop-up__message" dangerouslySetInnerHTML={{ __html: message }} />
            <div onClick={handleClose} style={{ cursor: 'pointer' }}>
                <Icon name="close" />
            </div>
        </div>
    )
}

export default PopUp